import React, { useState, useEffect } from "react";
import Toggle from "@atlaskit/toggle";
import { useDispatch, useSelector } from "react-redux";
import { saveFlow, selectFlow } from "../../../../redux/actions/integrationActions";
import { clone } from "../../../../common/utils/helper";
import { mergeCurrentActionToFlow } from "../../../../common/utils/integration.util";
import Tooltip from "@atlaskit/tooltip";

const ActionStatusToggle = ({ action, flow }) => {
  // Treat as enabled if action is null/undefined or if action.enabled is null/undefined
  const initialEnabled = action?.enabled ?? true;
  const [enabled, setEnabled] = useState(initialEnabled);
  const dispatch = useDispatch();
  const saved = useSelector((state) => state.integration.saved);

  useEffect(() => {
    if (enabled !== action?.enabled) {
      setEnabled(action?.enabled ?? true);
    }
  }, [action, enabled]);

  const toggleEnabled = () => {
    setEnabled(!enabled);
    let clonedFlow = clone(flow);
    action.enabled = !enabled;
    clonedFlow = mergeCurrentActionToFlow(action, clonedFlow);
    dispatch(selectFlow(clonedFlow));
    dispatch(saveFlow(flow));
  };
  const toggleTooltipText = (action?.enabled ? "Disable" : "Enable") + " this action";

  return (
    <div className="ihub-actionmenu-icons">
      <Tooltip position="top" content={toggleTooltipText}>
        <Toggle isChecked={enabled} onChange={toggleEnabled} />
      </Tooltip>
    </div>
  );
};

export default ActionStatusToggle;
